import { searchTodoItems } from '@erikdakoda/todo/ai-tools/searchTodoItems';
import { registerAiTool } from '@erikdakoda/ai-tool/aiToolRegistry';

registerAiTool(searchTodoItems);
